/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CourseRegistrationManagementStudentIndicatorViewModel } from "../types/CourseRegistrationManagementStudentIndicatorViewModel.ts";

export const courseRegistrationManagementStudentIndicatorViewModelSchema =
  z.object({
    indicationByEnrollment: z.optional(
      z
        .boolean()
        .describe(
          "Indica se a indicação foi feita via matrícula de outro aluno.",
        ),
    ),
    indicatorPersonId: z
      .number()
      .int()
      .describe("ID da pessoa indicadora. Opcional.")
      .nullish(),
    indicatorPersonFullName: z
      .string()
      .describe("Nome completo da pessoa indicadora. Opcional.")
      .nullish(),
    indicatorProgramUserLastChange: z
      .string()
      .describe(
        "Usuário que realizou a última alteração no programa de indicação. Opcional.",
      )
      .nullish(),
    indicatorProgramLastChangeDate: z
      .string()
      .datetime()
      .describe("Data da última alteração no programa de indicação. Opcional.")
      .nullish(),
  }) as unknown as ToZod<CourseRegistrationManagementStudentIndicatorViewModel>;
